<template>
  <b-table
      :fields="fields"
      :items="items"
      @row-clicked="onClickRow"
      table-class="text-nowrap"
      responsive
      hover
  >
    <template #cell(name)="data">
      <div class="d-flex align-items-center">
        <h4 class="mb-0">{{ data.item.name }}</h4>
      </div>
    </template>
    <template #cell(status)="data">
      <b-badge v-if="data.item.shipper.is_active" variant="success">Active</b-badge>
      <b-badge v-else variant="danger">Inactive</b-badge>
    </template>
  </b-table>
</template>

<script>
import {convertFromUtc} from "../helpers";

export default {
  name: "AdminShippersTable",
  props: {
    shippers: Array
  },
  data() {
    return {
      fields: [
        {
          key: "name",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "license",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "email",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "phone",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "status",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "date_added",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
      ]
    }
  },
  computed: {
    items() {
      return this.shippers.map(shipper => {
        return {
          shipper: shipper,
          name: shipper.name,
          license: shipper.license_number,
          email: shipper.email,
          phone: shipper.phone,
          date_added: convertFromUtc(shipper.created_at, 'L')
        }
      })
    }
  },
  methods: {
    onClickRow(item) {
      let shipperId = item.shipper.id;
      this.$router.push({ name: "admin-shipper", params: { id: shipperId.toString() } });
    }
  }
}
</script>
